<!-- =========================================================================================
  File Name: Reoptimization.vue
  Description: Reoptimization Create Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-user-edit">
		<vx-card>
			<re-optimization-edit-tab />
		</vx-card>
	</div>
</template>

<script>
import ReOptimizationEditTab from "./ReOptimizationEditTab.vue";
import moduleOptimization from "@/store/optimization/moduleOptimization.js";

export default {
	components: {
		ReOptimizationEditTab,
	},
	data() {
		return {
			timeWindow: null,
		};
	},
	created() {
		if (!moduleOptimization.isRegistered) {
			this.$store.registerModule("moduleOptimization", moduleOptimization);
			moduleOptimization.isRegistered = true;
		}
		this.getStandardInputById(parseInt(this.$route.params.id));
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		getStandardInputById(id) {
			const payload = {
				optimization_id: id,
				file_type: "standard_input",
			};
			this.openLoading();
			this.$store
				.dispatch("moduleOptimization/findById", payload)
				.then((res) => {
					this.closeLoading();
					this.$store.commit("moduleOptimization/SET_STANDARD_INPUT", res.data);
					return res;
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
	},
};
</script>

<style lang="scss" scoped>
#page-user-edit {
	height: 30%;
}
</style>
